import { HttpRequest } from "@angular/common/http";

export enum HttpRequestTypeEnum {
    get = 'get',
    post = 'post',
    put = 'put',
    delete = 'delete'
}
